var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.textLinkListProps),function(textLinkListProp,index){return _c('TextLinkList',_vm._b({key:index},'TextLinkList',textLinkListProp,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }